<template>
  <ul class="stage-picker clear-margin plr15">
      <li v-for="stageItem in stageRangeList" 
          :key="stageItem.name" 
          :class="classNames(stageItem)" 
          @click="onStageChange(stageItem)">
              <h3>{{stageItem.name}}</h3>
              <p>{{stageItem.startDate}}-{{stageItem.endDate}}</p>
              <p class="days-static-sp" v-if="stageItem.workdays">
                上课{{stageItem.workdays}}天，休息{{stageItem.freedays||0}}天
              </p>
              <p className="days-static-sp" v-else>&nbsp;</p>
      </li>
  </ul>
</template>
<script>
/**
 * 报课时期
 */
import './StagePicker.less'
export default {
  name: 'StagePicker',
  props: {
    stageRangeList: Array
  },
  data(){
    return {
      currentStage: this.stageRangeList&&this.stageRangeList[0]
    }
  },
  methods: {
    classNames(stageItem){
      return ["stage-picker-item", {selected: this.currentStage.name==stageItem.name}];
    },
    onStageChange(stage){
      this.currentStage = stage;
      this.$emit('onStageChange', stage);
    }
  },
  mounted(){
    
  }
}
</script>


// WEBPACK FOOTER //
// src/components/courseCenter/newsign/StagePicker.vue